<template>
     <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24">
                        <h1 class="text-center text-20">{{ data.form.title }}</h1>
                        <div class="text-center">
                            <div><img :src="data.form.src" style="width: 15%" /></div>
                        </div>
                        <div class="text-center mt-2">
                            <router-link :to="{ name: 'login' }">{{ $t("button.login") }}</router-link>
                        </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { Card, Col, Layout, Row } from "ant-design-vue";
import { defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../app.logic";
import { isLoading, initData } from "./active-email-token.logic";

export default defineComponent({
    components: {
        Card,
        Layout,
        Row,
        Col,
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        initData({data});
        return {
            props,
            data,
            refs,
            isLoading,
            initData
        };
    }
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
.card-item {
    text-align: center;
    width: 100%;
}
</style>
